import { makeStyles } from "@material-ui/core/styles";
import background from "../../../../assets/OfflineFunctionalityPreview.svg";

export const useStyles = makeStyles((theme) => ({
  imgContainer: {
    height: "525px",
    backgroundImage: `url(${background})`,
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    width: "325px",
    position: "relative",
    overflow: "hidden",
    "& .mui-rte-editor-container": {
      maxHeight: "260px !important",
      overflow: "hidden !important",
    },
    // Hide the clock widget from the exit function editor toolbar
    "& #mui-rte-toolbar": {
      "& > *:not(.leftAlignBtn):not(.centerAlignBtn):not(.rightAlignBtn):not(.increaceTextBtn):not(.decreaseTextBtn):not(.MuiButtonBase-root):not(.MuiIconButton-root)": {
        display: "none !important",
      },
    },
    // Hide clock widget specifically in the toolbar - more targeted approach
    "& #mui-rte-toolbar .MuiTypography-root": {
      display: "none !important",
    },
    "& #mui-rte-toolbar [data-testid*='clock']": {
      display: "none !important",
    },
    "& #mui-rte-toolbar [class*='clock']": {
      display: "none !important",
    },
    // Hide any non-button elements that might be clock widgets
    "& #mui-rte-toolbar > *:not(button):not(.MuiButtonBase-root):not(.MuiIconButton-root)": {
      display: "none !important",
    },
  },
  helpButtonEditorWrapper: {
    "& [class*='makeStyles-editorContainer']": {
      width: "calc(100% - 40px) !important",
      marginLeft: "20px !important",
      maxHeight: "200px !important",
      overflow: "hidden !important",
    },
  },
  qrCodeOverlay: {
    position: "absolute",
    bottom: "80px",
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 10,
    pointerEvents: "none",
  },
  backButtonOverlay: {
    position: "absolute !important",
    bottom: "20px",
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 10,
  },
  container: {
    paddingTop: "25px",
    margin: 0
  },
  toolbar: {
    position: "relative",
    textAlign: "center",
  },
  editorContainer: {
    maxHeight: "260px !important",
    paddingLeft: "20px",
    paddingRight: "20px",
    overflow: "hidden",
    "& .mui-rte-root": {
      maxHeight: "260px !important",
      overflow: "hidden !important",
    },
    "& .MUIRichTextEditor-root": {
      maxHeight: "260px !important",
      overflow: "hidden !important",
    },
    "& .MUIRichTextEditor-container": {
      maxHeight: "260px !important",
      overflow: "hidden !important",
    },
  },
  qrCodeOverlay: {
    position: "absolute",
    top: "310px",
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1,
  },
  backButtonOverlay: {
    position: "absolute",
    pointerEvents: "none",
    top: "430px",
    left: "50%",
    transform: "translateX(-50%)",
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    minWidth: "80px",
    zIndex: 1,
    textTransform: "none",
  },
  submitBtn: {
    marginTop: theme.spacing(2),
    width: "100px"
  },
  ticketExitFunctionDropdown: {
    paddingTop: "20px"
  },
  deviceMessageGrid: {
    display: "flex",
    justifyContent: "center",
    paddingTop: "0 !important",
    marginTop: "0 !important",
  },
  helpButtonDropdown: {
    paddingTop: "20px",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    width: "100%"
  },
  editButton: {
    marginLeft: theme.spacing(1),
    color: theme.palette.primary.main
  },
  helpButtonDrawerPaper: {
    width: "600px",
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    }
  },
  helpButtonEditorContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    overflow: "hidden"
  },
  helpButtonEditorHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper
  },
  closeButton: {
    color: theme.palette.grey[500]
  },
  helpButtonEditorContent: {
    flex: 1,
    padding: theme.spacing(3),
    overflowY: "auto",
    paddingTop: "0 !important",
    "& .MuiGrid-container": {
      marginTop: "0 !important",
      paddingTop: "0 !important",
    },
    "& .MuiGrid-item": {
      paddingTop: "0 !important",
    },
  },

  
  helpButtonEditorFooter: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(2),
    marginTop: theme.spacing(2)
  },
  cancelButton: {
    minWidth: "100px"
  },
  saveButton: {
    minWidth: "100px"
  },
  helpMessageEditor: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1)
  },
  // Clean overlay structure matching the working editor
  helpButtonEditorOverlay: {
    position: "absolute !important",
    top: "20px !important",
    left: "20px !important",
    right: "20px !important",
    height: "180px !important",
    maxHeight: "180px !important",
    minHeight: "180px !important",
    overflow: "hidden !important",
    zIndex: 2,
    "& *": {
      maxHeight: "180px !important",
    },
  },
  helpButtonQROverlay: {
    position: "absolute",
    top: "300px",
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1,
  },
  helpButtonBackButton: {
    position: "absolute",
    pointerEvents: "none",
    top: "420px",
    left: "50%",
    transform: "translateX(-50%)",
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    minWidth: "80px",
    zIndex: 1,
  },
  qrCodePreview: {
    display: "flex",
    justifyContent: "center",
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper
  },
  devicePreview: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    overflow: "hidden"
  },
  deviceScreen: {
    height: "400px",
    backgroundColor: "#000",
    color: "#fff",
    padding: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    position: "relative"
  },
  helpMessagePreview: {
    marginBottom: theme.spacing(2),
    "& div": {
      color: "#fff !important",
      textAlign: "center"
    }
  },
  qrCodeInPreview: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(2)
  },
  qrCodeTextPreview: {
    fontFamily: "monospace",
    fontSize: "12px",
    wordBreak: "break-all",
    whiteSpace: "pre-wrap",
    maxHeight: "200px",
    overflowY: "auto",
    padding: theme.spacing(1),
    backgroundColor: theme.palette.grey[100],
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius
  },
  qrCodeTextInPreview: {
    fontFamily: "monospace",
    fontSize: "10px",
    color: "#fff",
    textAlign: "center",
    wordBreak: "break-all",
    maxWidth: "200px"
  },
  errorContainer: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.error.light,
    color: theme.palette.error.contrastText,
    textAlign: "center"
  },
  offlineHelpButtonEditor: {
    width: "100% !important",
    marginLeft: "0 !important",
    maxHeight: "180px",
    overflow: "hidden",
    "& .public-DraftStyleDefault-block": {
      margin: "0 auto",
      maxWidth: "100%",
      whiteSpace: "pre-wrap",
    },
    "& .richTextEditor": {
      position: "relative",
    },
    "& .rte-align-left": {
      textAlign: "left !important",
    },
    "& .rte-align-center": {
      textAlign: "center !important",
    },
    "& .rte-align-right": {
      textAlign: "right !important",
    },
    "& .MuiToolbar-root": {
      position: "absolute !important",
      top: "0 !important",
      left: "0 !important",
      right: "0 !important",
      zIndex: 3,
      background: "white",
      borderBottom: "1px solid #ddd",
      padding: "4px 0",
      height: "36px",
      overflow: "hidden",
      whiteSpace: "nowrap",
      flexWrap: "nowrap",
      justifyContent: "center",
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      gap: "8px",
    },
    "& .MuiButtonBase-root": {
      minWidth: "32px",
      height: "32px",
      padding: "4px",
      margin: "0 2px",
      cursor: "pointer",
      visibility: "visible !important",
      opacity: "1 !important",
    },
    "& .MuiIconButton-root": {
      padding: "4px",
      margin: "0 2px",
      visibility: "visible !important",
      opacity: "1 !important",
    },
    "& .leftAlignBtn, & .centerAlignBtn, & .rightAlignBtn": {
      visibility: "visible !important",
      opacity: "1 !important",
      display: "inline-flex !important",
    },
    // Hide only the clock widget from the toolbar, keep all other buttons
    "& #mui-rte-toolbar": {
      "& > *:not(.leftAlignBtn):not(.centerAlignBtn):not(.rightAlignBtn):not(.increaceTextBtn):not(.decreaseTextBtn):not(.MuiButtonBase-root):not(.MuiIconButton-root)": {
        display: "none !important",
      },
    },
  }, enableAccessCredentialBuffering: {
    paddingTop: "20px"
  },
  helpButtonRTEContainer: {
    position: "relative !important",
    margin: "0 !important",
    height: "180px !important",
    maxHeight: "180px !important",
    minHeight: "180px !important",
    overflow: "hidden !important",
    boxSizing: "border-box !important",
    "& > div": {
      height: "180px !important",
      maxHeight: "180px !important",
      minHeight: "180px !important",
      overflow: "hidden !important",
    },
  },
  offlineHelpButtonToolbar: {
    position: "relative !important",
    marginTop: "0px",
    textAlign: "center",
  },
  }  
));
